import React, { Component } from 'react';
import { Spin, Descriptions } from 'antd';
import { withRouter, } from 'react-router-dom';
import { detailAPI } from '../../api/parl.js'
import '../../assets/css/common.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'
import './index.css'
class parlDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataSource: [],
			currMeeting: '',
			currCountry: '',
			tbName: ''
		}
	}

	componentDidMount() {
		//获取url参数
		let query_params = new URLSearchParams(this.props.location.search);
		let tb_name = query_params.get("tb_name");
		this.setState({ currCountry: this.props.match.params.country, currMeeting: this.props.match.params.id, tbName: tb_name }, () => { this.fetchDetail() })
	}

	fetchDetail = () => {
		const { currCountry, currMeeting } = this.state;
		var params = { auto_id: currMeeting }
		if (currCountry === 'fr' || currCountry === 'ge' || currCountry === 'pl' || currCountry === 'tr' || currCountry === 'my'
			|| currCountry === 'pk' || currCountry === 'sg' || currCountry === 'nz' || currCountry === 'za' || currCountry === 'at' || currCountry === 'india' || currCountry == 'ca') {
			params.tb_name = this.state.tbName
		}
		detailAPI(currCountry, params)
			.then(res => {
				var data = res.data.data
				console.log(currCountry, Object.keys(data), data);

				this.setState({ dataSource: data })
			})
	}

	render() {
		const { dataSource, currCountry } = this.state;

		const usEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="每日摘要(Daily Digest)">{dataSource.daily_digest}</Descriptions.Item>
				<Descriptions.Item label="期号(Issue No.)">{dataSource.date_and_issue_no}</Descriptions.Item>
				<Descriptions.Item label="备注扩展(Extensions of Remarks)">{dataSource.extensions}</Descriptions.Item>
				<Descriptions.Item label="众议院(House)">{dataSource.house}</Descriptions.Item>
				<Descriptions.Item label="参议院(Senate)">{dataSource.senate}</Descriptions.Item>
				<Descriptions.Item label="Entire Issue">{dataSource.entire_issue}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.pdf_url}>{dataSource.pdf_url}</a></Descriptions.Item>
			</Descriptions>
		)

		// const caEle = (
		// 	<Descriptions bordered title={dataSource.speech_date} column={1} labelStyle={{fontWeight: 'bold', width: 150}}>
		// 		<Descriptions.Item label="主题(Main Topic)">{dataSource.main_topic}</Descriptions.Item>
		// 		<Descriptions.Item label="发言人(Speaker)">{dataSource.speaker_name}</Descriptions.Item>
		// 		<Descriptions.Item label="Speaker Party">{dataSource.speaker_party}</Descriptions.Item>
		// 		<Descriptions.Item label="Speaker Position">{dataSource.speaker_position}</Descriptions.Item>
		// 		<Descriptions.Item label="Sub Topic">{dataSource.sub_topic}</Descriptions.Item>
		// 		<Descriptions.Item label="Base PK">{dataSource.base_pk}</Descriptions.Item>
		// 		<Descriptions.Item label="Hid">{dataSource.hid}</Descriptions.Item>
		// 		<Descriptions.Item label="Speaker Old Name">{dataSource.speaker_old_name}</Descriptions.Item>
		// 		<Descriptions.Item label="Speaker Riding">{dataSource.speaker_riding}</Descriptions.Item>
		// 		<Descriptions.Item label="Speech Text" span={2}>{dataSource.speech_text}</Descriptions.Item>
		// 		<Descriptions.Item label="Sub Sub Topic">{dataSource.sub_sub_topic}</Descriptions.Item>
		// 		<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.speaker_url}>{dataSource.speaker_url}</a></Descriptions.Item>
		// 	</Descriptions>
		// )

		const caEle = (
			<Descriptions bordered title={dataSource.speech_date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="日期(Date)">{dataSource.date}</Descriptions.Item>
				<Descriptions.Item label="议院(Chamber)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="届(Parliament)">{dataSource.parliament}</Descriptions.Item>
				<Descriptions.Item label="次(Session)">{dataSource.session}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
				<Descriptions.Item label="议会文本"><a target="_blank" href={dataSource.pdfurl}>{dataSource.pdfurl}</a></Descriptions.Item>
			</Descriptions>
		)

		const euEle = (
			<Descriptions bordered title={dataSource.date_str} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="标题(Title)">{dataSource.title}</Descriptions.Item>
				<Descriptions.Item label="委员会(Committee)">{dataSource.type}</Descriptions.Item>
				<Descriptions.Item label="文档类型(Document Type)">{dataSource.empl_value}</Descriptions.Item>
				<Descriptions.Item label="Pe Number">{dataSource.pe_value}</Descriptions.Item>
				<Descriptions.Item label="Post By">{dataSource.post_by}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.pdf_url}>{dataSource.pdf_url}</a></Descriptions.Item>
			</Descriptions>
		)

		const ruEle = (
			<Descriptions bordered title={dataSource.date_info} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="议院(Палата)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="发布者(Разместил)">{dataSource.post_by}</Descriptions.Item>
				<Descriptions.Item label="发布日期(Дата Размещения)">{dataSource.post_date}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.document_url}>{dataSource.document_url}</a></Descriptions.Item>
			</Descriptions>
		)

		const frEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="标题(Civilité)">{dataSource.title}</Descriptions.Item>
				<Descriptions.Item label="会期(Séance)">{dataSource.type}</Descriptions.Item>
				<Descriptions.Item label="议院(Assemblée)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const geEle = (
			<Descriptions bordered title={dataSource.date_info} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="标题(Titel)">{dataSource.title}</Descriptions.Item>
				{/* <Descriptions.Item label="Type">{dataSource.type}</Descriptions.Item> */}
				<Descriptions.Item label="议院(Parlament)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const plEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="期(Posiedzenie)">{dataSource.posiedzenie}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const trEle = (
			<Descriptions bordered title={dataSource.tarih} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="标题(Başlıkları)">{dataSource.title}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		let pkCategory = ''
		if (dataSource.category && dataSource.category === 'Se') {
			pkCategory = 'Senate'
		}
		if (dataSource.category && dataSource.category === 'Na') {
			pkCategory = 'National Assembly'
		}

		const pkEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 220 }}>
				<Descriptions.Item label="议会类型(Category)">{pkCategory}</Descriptions.Item>
				<Descriptions.Item label="年度(Parliamentary Year)">{dataSource.parliamentaryyear}</Descriptions.Item>
				<Descriptions.Item label="次(Session)">{dataSource.session}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const sgEle = (
			<Descriptions bordered title={dataSource.title} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="日期(Date)">{dataSource.date}</Descriptions.Item>
				<Descriptions.Item label="卷号(Volume)">{dataSource.vol}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const nzEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="标题(Title)">{dataSource.title}</Descriptions.Item>
				<Descriptions.Item label="文档类型(Document Type)">{dataSource.documenttype}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		let zaCategory = ''
		if (dataSource.category && dataSource.category === 'HP') {
			zaCategory = 'National Assembly'
		}
		if (dataSource.category && dataSource.category === 'Bills') {
			zaCategory = 'National Council of Provinces'
		}
		const zaEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="文件(File)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="议会类型(House)	">{dataSource.house}</Descriptions.Item>
				<Descriptions.Item label="语言(Language)	">{dataSource.language}</Descriptions.Item>
				<Descriptions.Item label="文档类型(Type)">{dataSource.type}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const atEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="类型(Typ)">{dataSource.subject}</Descriptions.Item>
				<Descriptions.Item label="时期(Periode)">{dataSource.period}</Descriptions.Item>
				<Descriptions.Item label="议院(Parlament)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="会期(Sitzung)">{dataSource.type}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		let indiaCategory = ''
		if (dataSource.category && dataSource.category === 'LS') {
			indiaCategory = 'Lok Sabha'
		}
		if (dataSource.category && dataSource.category === 'RS') {
			indiaCategory = 'Rajya Sabha'
		}
		const indiaEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="议院(Sansad)">{indiaCategory}</Descriptions.Item>
				<Descriptions.Item label="期(Session)">{dataSource.session}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const myEle = (
			<Descriptions bordered title={dataSource.date} column={1} labelStyle={{ fontWeight: 'bold', width: 150 }}>
				<Descriptions.Item label="议院(Dewan)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="届(Parlimen)">{dataSource.session}</Descriptions.Item>
				<Descriptions.Item label="期(Penggal)">{dataSource.term}</Descriptions.Item>
				<Descriptions.Item label="次(Mesyuarat)">{dataSource.meeting}</Descriptions.Item>
				<Descriptions.Item label="详情页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const contentEle = Object.keys(dataSource).length > 0 ? {
			'us': usEle, 'ca': caEle, 'eu': euEle, 'ru': ruEle, 'fr': frEle, 'ge': geEle, 'pl': plEle, 'tr': trEle,
			'pk': pkEle, 'sg': sgEle, 'nz': nzEle, 'za': zaEle, 'at': atEle, 'india': indiaEle, 'my': myEle,
		}[currCountry]
			: (
				<div style={{ width: '100%', textAlign: 'center', paddingTop: '10%' }}>
					<Spin tip="数据加载中..." style={{ margin: 'auto' }}></Spin>
				</div>
			)

		return (
			<div style={{ margin: '40px 15%', }}>
				<MyBreadcrumb urls={[
					{
						url: '/database/parl/' + currCountry, breadcrumbName: {
							'uk': '英国议会', 'us': '美国议会', 'ca': '加拿大议会', 'eu': '欧洲议会',
							'ru': '俄罗斯杜马', 'fr': '法国议会', 'ge': '德国议会', 'pl': '波兰议会', 'tr': '土耳其议会',
							'pk': '巴基斯坦议会', 'sg': '新加坡议会', 'nz': '新西兰议会', 'za': '南非议会', 'at': '奥地利议会', 'india': '印度议会', 'my': '马来西亚议会'
						}[currCountry] + ''
					},
					{ breadcrumbName: '详情' },
				]} />
				{contentEle}
			</div>
		);
	}
}

export default withRouter(parlDetail)
